import styled, { css } from 'styled-components'

import type { SubscriptionPerkIconAppearance } from './SubscriptionPerk.types'

export const Container = styled.div`
  display: flex;
  align-items: center;
`

export const IconContainer = styled.div<{ $appearance: SubscriptionPerkIconAppearance }>`
  margin-right: var(--space-250);

  ${({ $appearance }) =>
    $appearance === 'highlighted' &&
    css`
      color: var(--border-pro);
    `}
`

export const ContentContainer = styled.div`
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-400);
`

export const TooltipContainer = styled.div`
  margin-right: var(--space-150);
  cursor: pointer;
`
